import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const TrainingIcon = ({ width, height, color }: IProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width ?? 24}
            height={height ?? 24}
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.34786 0C3.14881 0 2.17394 0.974864 2.17394 2.17391C2.17394 3.37296 3.14881 4.34783 4.34786 4.34783C5.54691 4.34783 6.52177 3.37296 6.52177 2.17391C6.52177 0.974864 5.54691 0 4.34786 0ZM11.7392 0V0.869565H7.09245C7.28097 1.26529 7.39137 1.70686 7.39137 2.17391C7.39137 2.82099 7.19266 3.41882 6.84789 3.91304H11.5218C12.6003 3.91304 13.4783 4.7911 13.4783 5.86956C13.4783 6.94803 12.6003 7.82609 11.5218 7.82609H7.82615V13.913H19.5653C19.8064 13.913 20.0001 13.7194 20.0001 13.4783V1.30435C20.0001 1.06488 19.8064 0.869565 19.5653 0.869565H12.6088V0H11.7392ZM0 7.17395C0 5.85602 1.07337 4.78265 2.3913 4.78265H2.83967L4.34783 7.82613L5.88315 4.78265H11.5217C12.123 4.78265 12.6087 5.26838 12.6087 5.86961C12.6087 6.47083 12.123 6.95656 11.5217 6.95656H6.95652V18.8316C6.95652 19.5109 6.58967 20 5.91033 20C5.3091 20 4.85564 19.5551 4.79619 18.9538C4.79535 18.9521 4.79237 18.953 4.7894 18.9538C4.78643 18.9547 4.78346 18.9555 4.78261 18.9538V13.7772C4.78261 13.6566 4.6858 13.5598 4.56522 13.5598C4.44463 13.5598 4.34783 13.6566 4.34783 13.7772V18.8316C4.34783 19.5007 3.86379 20 3.22011 20C2.53906 20 2.17391 19.5109 2.17391 18.8316V8.07069C2.17391 7.95351 2.07371 7.8533 1.95652 7.8533C1.83933 7.8533 1.73913 7.95351 1.73913 8.07069V13.0435C1.73913 13.5242 1.34851 13.9131 0.869565 13.9131C0.390625 13.9131 0 13.5242 0 13.0435V7.17395ZM11.087 14.7827L9.13047 18.6957H10L11.9566 14.7827H11.087ZM14.3478 18.6957L12.3913 14.7827H13.2609L15.2174 18.6957H14.3478Z'
                fill={color ?? colors.grey[50]}
            />
        </svg>
    )
}

export default React.memo(TrainingIcon)
